// export const url = "https://pizzame-backend.herokuapp.com/";

// export const url = "/api";
export const url =
  !process?.env?.NODE_ENV || process?.env?.NODE_ENV === "development"
    ? ""
    : "/api";
